module.exports = __webpack_public_path__ + "img/jihe3.09985ee3.png";